<mat-form-field class="example-full-width" >
  <mat-label>Leave a comment</mat-label>
  <textarea matInput placeholder="Ex. It makes me feel..." (change)="changedText($event)" ></textarea>
</mat-form-field>
<!--<mat-form-field class="example-full-width">-->
<!--  <mat-label>Favorite food</mat-label>-->
<!--  <input matInput placeholder="Ex. Pizza" value="Sushi" (change)="changedText()">-->
<!--</mat-form-field>-->
<div>{{translatedCode}}</div>
